/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-27 15:27:59
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2024-12-25 13:52:31
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\lang\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const page_footer = {
  follow: 'Follow Us',
  wechat: 'WeChat',
  user: 'User Type',
  first: 'Starter',
  forStudent: 'Student',
  forEducator: 'Educator',
  forDeveloper: 'Developer',
  forCompany: 'Company',
  union: 'Industry Alliance',
  solution: 'Industry Solutions',
  chemiq: 'Biochemistry',
  educate: 'Education',
  finance: 'Fintech',
  bigData: 'Big Data',
  power:'Power Industry',
  ai: 'AI',
  engineering: 'Engineering Design',
  pro_serve: 'Products & Services',
  superQuantum: 'Wuyuan Superconducting Quantum Computer',
  // superQuantum: 'Wuyuan Superconducting',
  quantumChip: 'Kuafu Series Superconducting Quantum Processor',
  // quantumChip: 'Kuafu Series Superconducting',
  control_instrumentation: 'Quantum Computer Control Instruments',
  // control_instrumentation: 'Computer Control Instruments',
  cal_servies: 'Quantum Computing Service',
  app_serve: 'Application Service',
  learn_pro: 'Education Products',
  learn: 'Learning',
  course: 'Courses',
  learn_machine: 'Learning Machine',
  teach_platfrom: 'Quantum T&R Platform',
  doc_center: 'Documents',
  // contest: 'Programming Challenge',
  // contest: 'Programming Challenge',
  contest: 'Competition Platform',
  forum: 'Community',
  company: 'Origin Quantum',
  about: 'About Us',
  newslist: 'News',
  recruit: 'Join Us',
  OriginqInformation:
    'Copyright © 2017 - {{year}} Origin Quantum. All Rights Reserved. 本源量子版权所有',
  copyRight: 'All Rights Reserved',
  areaOriginqInfo: '皖ICP备 17025557号-1',
  areaOriginqText: 'Anhui Public Network  No. 34011102000802',
  aboutOrgin: 'About Origin Quantum',
  originLearningMechine: 'Origin Quantum Learning<br/> Machine',
  officalPublicNumber: 'Official Account',
  officalBlog: 'Official Microblog',
  OriginqService: '《Service Agreement》',
  OriginqPrivacy: '《Privacy Policy》',
  footer_desc:'本源量子计算云平台聚焦于量子计算云服务，为用户提供学习资源、编程工具、算力服务、应用开发等全流程服务，致力于推动量子计算的创新和应用，探索量子计算的无限潜力。',
  service:'云服务',
  service_quantum:'量子计算服务',
  service_lh:'融合计算服务',
  service_special: '专用量子云平台',
  tools:'编程工具',
  Qpanda:'QPanda',
  VQNet:'VQNet',
  pqypanda:'pyqpanda-algorithm',
  qrunes:'QRunes',
  qurator: 'Qurator',
  application:'量子应用',
  finitch:'金融科技',
  bio:'生物医药',
  artifical:'人工智能&大数据',
  info:'信息安全',
  other: '其他',
  learnSource:'学习资源',
};
export default page_footer;
